<template>
  <div>
    <div>
      <el-form
        ref="form"
        label-width="160px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="序号：">
              <el-input
                v-model="data.serialNo"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报文类型：">
              <el-input
                v-model="data.socketType"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="服务号：">
              <el-input
                v-model="data.serviceNo"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交易标注：">
              <el-input
                v-model="data.transMakr"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="交易码：">
              <el-input
                v-model="data.transHead"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="终端号：">
              <el-input
                v-model="data.terminalNo"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="设备编号：">
              <el-input
                v-model="data.deviceId"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡号：">
              <el-input
                v-model="data.cardNo"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="客户号：">
              <el-input
                v-model="data.cis"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交易时间：">
              <el-input
                v-model="data.transTime"
                style="width:100%"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-row>
            <el-col :span="12">
              <el-form-item label="错误代码：">
                <el-input
                  v-model="data.errorcode"
                  style="width:100%"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="错误信息：">
                <el-input
                  v-model="data.errormessage"
                  style="width:100%"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="定位：">
                <el-input
                  v-model="data.errorlocation"
                  style="width:100%"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="错误描述：">
                <el-input
                  v-model="data.errordescription"
                  style="width:100%"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="接受报文时间：">
                <el-input
                  v-model="data.transRespTime"
                  style="width:100%"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报文日志ID：">
                <el-input
                  v-model="data.id"
                  style="width:100%"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="状态：">
                <el-input
                  v-model="data.transStatus"
                  style="width:100%"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="网点：">
                <el-input
                  v-model="data.orgnCode"
                  style="width:100%"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>

        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="发送报文：">
              <el-input
                type="textarea"
                :rows="6"
                readonly="readonly"
                v-model="data.socketSend"
                class='textInput'
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="接收报文：">
              <el-input
                type="textarea"
                :rows="6"
                readonly="readonly"
                v-model="data.socketRec"
                class='textInput'
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="错误堆栈：">
              <el-input
                type="textarea"
                :rows="6"
                readonly="readonly"
                v-model="data.errorstack"
                class='textInput'
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: JSON.parse(sessionStorage.getItem('translogsocketDetail')),
    };
  },
};
</script>
<style scoped lang="scss">
</style>
